import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* About */}
          <div>
            <h3 className="font-serif text-lg mb-4">THE GEM ATELIER</h3>
            <p className="text-sm text-gray-400 leading-relaxed">
              Curators of Exceptional Gems
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-sans text-sm uppercase tracking-wider mb-4">Shop</h4>
            <ul className="space-y-2 text-sm">
              <Link to="/shop?gem_type=emerald" className="text-gray-400 hover:text-white transition-colors block">Emeralds</Link>
              <Link to="/shop?gem_type=ruby" className="text-gray-400 hover:text-white transition-colors block">Rubies</Link>
              <Link to="/shop?gem_type=sapphire" className="text-gray-400 hover:text-white transition-colors block">Sapphires</Link>
              <Link to="/shop" className="text-gray-400 hover:text-white transition-colors block">All Gems</Link>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="font-sans text-sm uppercase tracking-wider mb-4">Customer Service</h4>
            <ul className="space-y-2 text-sm">
              <Link to="/about" className="text-gray-400 hover:text-white transition-colors block">About Us</Link>
              <Link to="/birthstones" className="text-gray-400 hover:text-white transition-colors block">Birthstones</Link>
              <Link to="/contact" className="text-gray-400 hover:text-white transition-colors block">Contact</Link>
              <Link to="/track-order" className="text-gray-400 hover:text-white transition-colors block">Track Order</Link>
              <Link to="/shipping" className="text-gray-400 hover:text-white transition-colors block">Shipping & Returns</Link>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-sans text-sm uppercase tracking-wider mb-4">Connect</h4>
            <div className="flex space-x-4 mb-6">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
            <div className="text-sm text-gray-400 space-y-2">
              <Link to="/contact" className="hover:text-white transition-colors block">Send us a message</Link>
              <Link to="/request-stone" className="hover:text-white transition-colors block">Request a Stone</Link>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} The Gem Atelier. All rights reserved.</p>
          <div className="mt-2 space-x-4">
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <span>•</span>
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;